import styled from 'styled-components';

export const ModalTwoButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  grid-row-gap: 30px;
`;
